import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { AgGridProvider } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "queryClient";
import "index.css";

import App from "App";
import store from "app/store";
import theme from "theme";
import NotificationProvider from "context/NotificationProvider";

const modules = [AllCommunityModule];

const root = ReactDOM.createRoot(document.getElementById("root"));

// TypeScript only:

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <AgGridProvider modules={modules}>
                        <NotificationProvider>
                            <CssBaseline />
                            <App />
                        </NotificationProvider>
                    </AgGridProvider>
                </ThemeProvider>
            </Provider>
        </QueryClientProvider>
    </React.StrictMode>
);
